import React from 'react';
import PropTypes from 'prop-types';
import clsx from '@strava/ui/clsx';

import styles from './Inset.scss';

const Inset = ({ children, transparent, className, dataTestId }) => (
  <div
    className={clsx(
      styles.container,
      transparent && styles.transparent,
      className
    )}
    data-testid={dataTestId}
  >
    {children}
  </div>
);

Inset.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  dataTestId: PropTypes.string,
  transparent: PropTypes.bool
};

Inset.defaultProps = {
  className: null,
  dataTestId: undefined,
  transparent: false
};

export default Inset;
